// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","477":"LogoMakerGuestLazyComponent"}[chunkId] + "." + {"46":"319448c3c3918e97f06c","477":"3eff6b94ce38ccd861e7"}[chunkId] + ".js";
};